import React from "react";
import { useRelatorios } from "context/RelatorioContext";

interface Props {
  selectedPeriodo: string;
}

export default function RelatorioTrafego({ selectedPeriodo }: Props) {
  const { relatorios } = useRelatorios();
  const dataHojeStr = new Date().toISOString().split("T")[0];

  const totalHoje = relatorios
    .filter(r => {
      const matchData = r.Data === dataHojeStr;
      const matchPeriodo = selectedPeriodo === "Todos" || r.expediente === selectedPeriodo;
      return matchData && matchPeriodo;
    })
    .reduce((sum, r) => sum + r.contador, 0);

  const relatoriosFiltradosPorPeriodo = relatorios.filter(r => 
    selectedPeriodo === "Todos" || r.expediente === selectedPeriodo
  );

  const agregados = relatoriosFiltradosPorPeriodo.reduce((map: Record<string, number>, r) => {
    map[r.Data] = (map[r.Data] || 0) + r.contador;
    return map;
  }, {});

  const entradas = Object.entries(agregados)
    .map(([Data, total]) => ({ Data, total }))
    .sort((a, b) => new Date(b.Data).getTime() - new Date(a.Data).getTime())
    .slice(0, 4);

  const maxTotal = Math.max(...entradas.map(e => e.total), 1);

  return (
    <div className="p-4 bg-white rounded-xl shadow">
      <h2 className="text-lg font-bold text-navy-700">
        Tráfego por Dia
      </h2>
      <p className="text-[34px] font-bold text-navy-700">
        {totalHoje} <span className="text-sm font-medium leading-6 text-gray-600">Pessoas Hoje</span>
      </p>
      <div className="flex gap-4 pt-4">
        {entradas.map((e) => {
          const altura = Math.round((e.total / maxTotal) * 100);
          const [, month, day] = e.Data.split("-");
          const dataFormatada = `${day}/${month}`;
          return (
            <div key={e.Data} className="flex flex-col items-center h-full w-full">
              <span className="text-sm font-bold h-[20px]">{e.total}</span>
              <div className="h-[200px] w-6 bg-gray-200 rounded-full flex items-end">
                <div
                  className="bg-[#B84343] w-full rounded-full transition-all duration-300"
                  style={{ height: `${altura}%` }}
                />
              </div>
              <span className="text-xs text-gray-600 rotate-45 origin-bottom-left whitespace-nowrap">
                {dataFormatada}
              </span>
            </div>
          );
        })}
      </div>
        {entradas.length === 0 && (
          <div className="text-center text-gray-500 pt-8">
            Nenhum dado para exibir.
          </div>
        )}
    </div>
  );
}
